import { Button, Stack, Typography } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useLocation, useNavigate } from 'react-router';

import { MessageScreen } from '../../../../../components/MessageScreen/MessageScreen';
import ArchiveCheckIconSvg from '../../../../../assets/icons/archive-doc-check.svg?react';
import { isKPIPendingSubmission } from '../../../../../data-models/kpi-requests.data-model';
import { assignedKPIRequestsStateByCompanyJ } from '../../../../../services/state/KPI/KPITemplatesStateJ';
export function KPIThankYouScreen() {
  const location = useLocation();
  const companyId = Number(location.state?.companyId ?? -1);
  const navigate = useNavigate();
  const allRequests = useAtomValue(assignedKPIRequestsStateByCompanyJ);
  const hasPendingRequests =
    allRequests.get(companyId)?.some((request) => isKPIPendingSubmission(request.status)) ?? false;

  const goToPendingRequest = () => {
    navigate(`/kpis/pending-requests/${companyId}`);
  };

  return (
    <MessageScreen>
      <Stack alignItems={'center'} justifyContent={'flex-end'} gap={'1rem'}>
        <ArchiveCheckIconSvg />
        <Typography variant='h1'>Thank you!</Typography>
        {hasPendingRequests && (
          <>
            <Typography variant='h6' mt={'1rem'}>
              {`You still have pending requests`}
            </Typography>
            <Button color={'secondary'} variant={'contained'} onClick={goToPendingRequest}>
              Go to pending request
            </Button>
          </>
        )}
      </Stack>
    </MessageScreen>
  );
}
